import { render, staticRenderFns } from "./DisableCommunicationsGroup.vue?vue&type=template&id=be6b518c&scoped=true&"
import script from "./DisableCommunicationsGroup.vue?vue&type=script&lang=js&"
export * from "./DisableCommunicationsGroup.vue?vue&type=script&lang=js&"
import style0 from "./DisableCommunicationsGroup.vue?vue&type=style&index=0&id=be6b518c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b518c",
  null
  
)

export default component.exports